import script from "./TableRows.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableRows.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
